import { render, staticRenderFns } from "./DataAnalysisChartViewComponent.vue?vue&type=template&id=a896b5a8"
import script from "./DataAnalysisChartViewComponent.vue?vue&type=script&lang=js"
export * from "./DataAnalysisChartViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports